import { MasterHelper } from '../../utilities';
import { TrailType } from './../../enums/user/trail-type';
import { AdditionalFilter } from '../rulebook/additional-filter';

export class AuditTrailDto extends AdditionalFilter {
  fromDate: string;
  toDate: string;
  auditTrailType: TrailType;
  users: string[];
  screens: string[];
  functions: string[];
  actions: string[];

  constructor() {
    super();
    this.fromDate = MasterHelper.getDateStr(30);
    this.toDate = MasterHelper.getDateStr(0);
    this.auditTrailType = TrailType.Unknown;
    this.users = [];
    this.screens = [];
    this.functions = [];
    this.actions = [];
  }
}
